





































































import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import TrackerFormComponent from "./Tracker/TrackerForm.vue";
import DataTable from "@/components/common/Tables/DataTable.vue";
import { ReportFilter, ReportParameter } from "@/entities";
import AdvanceSearchComponent from "@/components/common/AdvanceFilter/AdvanceSearch.vue";
import BackButtonComponent from "./Dashboard/BackButton.vue";

@Component({
  components: {
    TrackerFormComponent,
    AdvanceSearchComponent,
    BackButtonComponent,
    DataTable,
  },
})
export default class CommunicationDocumentComponent extends Vue {
  search: string = "";
  data: any = [];
  refReport: string = "trackerTable";
  isLoading: boolean = false;
  showDialog: boolean = false;
  selectedItem: any = {};
  fields: Array<ReportFilter> = [];
  selectedParams: Array<ReportParameter> = [];
  downloadLoader = false;
  disableDownload = false;
  update = 0;

  /** Column headers */
  headers: any = []; 

  mounted() {
    this.headers = this.$services.communication.communicationDocCols;
    this.headers.map(x => {
            x.text = this.$t(x.text);
        });
    this.isLoading=true
    // #. populate the grid data..
    this.$services.communication
      .getCommunicationDocs(this.selectedParams)
      .then((data) => {
        data.forEach((x) => {
          if (x["downloadLoader"] == null || x["downloadLoader"] == undefined) {
            x["downloadLoader"] = false;
          }
          if (
            x["disableDownload"] == null ||
            x["disableDownload"] == undefined
          ) {
            x["disableDownload"] = false;
          }
        });
        this.data = data;
        this.isLoading=false
      });

    // #. get the filter options..
    this.$services.communication.getCommunicationDocsFilters().then((data) => {
      this.fields = data;
    });
  }

  // dynamic slots of the table..
  dynamicSlots = {
    vDataTable: [
      {
        name: "item.FileName",
      },
    ],
  };

  /** download the file */
  download(doc) {
    doc.downloadLoader = true;
    doc.disableDownload = true;
    this.$services.document
      .download({
        documentId: doc.DocumentStoreDetailId,
        uploadedFileName: doc.UploadedName,
      })
      .then((data) => {
        doc.downloadLoader = false;
        doc.disableDownload = false;
      })
      .catch((e) => {
        doc.downloadLoader = false;
        doc.disableDownload = false;
      });
  }

  // generate the report
  generateReport() {
    this.data = [];
    this.isLoading = true;
    this.$services.communication
      .getCommunicationDocs(this.selectedParams)
      .then((data) => {
        data.forEach((x) => {
          if (x["downloadLoader"] == null || x["downloadLoader"] == undefined) {
            x["downloadLoader"] = false;
          }
          if (
            (x["disableDownload"] = null || x["disableDownload"] == undefined)
          ) {
            x["disableDownload"] = false;
          }
        });
        this.data = data;
        this.isLoading = false;
      });
  }
}
